<template>
  <div class="about">
    <HeaderStyle1>
<!--      <h1 slot="title" v-html="$t('about-head-h1')"></h1>-->
<!--      <p slot="detail" v-html="$t('about-head-small')"></p>-->
<!--      <b-img class="header-img" slot="image" src="../assets/imgs/head-img-contacts.png" alt=""></b-img>-->
    </HeaderStyle1>

    <b-container fluid="xl">
      <b-row class="section-introduction">
        <b-col>
          <h2>{{$t('about-introduction-title')}}</h2>
          <p v-html="$t('about-introduction-content')"></p>
        </b-col>
      </b-row>
      <b-row class="section-contact">
        <b-col>
          <h2>{{$t('about-contact-title')}}</h2>
          <p v-html="$t('about-content-content')"></p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import HeaderStyle1 from '../components/HeaderStyles4.vue'

export default {
  name: 'Contacts',
  components: {
    HeaderStyle1
  },
  mounted () {
    document.title = '关于我们'
  }
}
</script>
<style scoped lang="scss">
  .about {
    padding-bottom: 100px;

    .header-img {
      max-width: 80%;
      margin-bottom: 74px
    }

    h2 {
      font-size: 34px;
      font-weight: 700;
      color: #000000;
      margin: 50px 0 40px 0;
    }

    .section-introduction {
      p {
        font-size: 18px;
        font-weight: 400;
        color: #000000;
        line-height: 30px;
      }
    }

    .section-contact {
      p {
        line-height: 60px;
      }
    }
  }
</style>
<style scoped lang="scss">
  @media (max-width: 768px) {
    .about {
      padding-bottom: 100px;

      .header-img {
        max-width: 80%;
        margin-bottom: 10px
      }

      h2 {
        font-size: 18px;
        font-weight: 700;
        color: #000000;
        margin: 20px 0 10px 0;
      }

      .section-introduction {
        p {
          font-size: 13px;
          font-weight: 400;
          color: #000000;
          line-height: 1.5;
        }
      }

      .section-contact {
        p {
          line-height: 60px;
          font-size: 13px;
        }
      }
    }
  }
</style>
